<template>
  <div id="app" class="m-grid m-grid--hor m-grid--root m-page">
    <transition name="fade">
      <router-view v-if="loaded"></router-view>
    </transition>
    <!-- begin::Scroll Top -->
    <div id="m_scroll_top" class="m-scroll-top">
      <i class="la la-arrow-up"></i>
    </div>
    <!-- end::Scroll Top -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      loader: true,
      loaded: false
    }
  },
  methods: {
    setLanguage () {
      let lang = this.$store.state.loading.language
      if (localStorage.getItem('language') !== null) {
        lang = localStorage.getItem('language')
      }

      this.$translate.locale = lang
      this.$translate.setLocaleMessage(lang, this.$store.state.loading.languages[lang])
      this.$store.commit('loading/changeLanguage', lang)
    }
  },
  beforeMount () {
    this.$nextTick(function () {
      this.$http.get(`${process.env.API_URL}/api/v1/admin/translation/hu`)
        .then(res => {
          this.$store.commit('loading/setLanguage', {lang: 'hu', payload: res.data})
          this.setLanguage()
          this.loaded = true
        })

      this.$http.get(`${process.env.API_URL}/api/v1/admin/translation/en`)
        .then(res => {
          this.$store.commit('loading/setLanguage', {lang: 'en', payload: res.data})
          this.setLanguage()
        })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue